import { gql } from "urql"

export default gql`
  query AdminMatchedStudents($sourceUserId: ID!, $page: Int!) {
    tutor(id: $sourceUserId) {
      matchedUsers(page: $page) {
        totalPages
        currentPage
        data {
          id
          showPath
          fullName
          lastName
          tutorToStudentPhoneNumber(tutorId: $sourceUserId)
          tutorToParentPhoneNumber(tutorId: $sourceUserId)
          tutorToSecondaryParentPhoneNumber(tutorId: $sourceUserId)
          studentToTutorPhoneNumber(tutorId: $sourceUserId)
          parentToTutorPhoneNumber(tutorId: $sourceUserId)
          secondaryParentToTutorPhoneNumber(tutorId: $sourceUserId)
        }
      }
    }
  }
`
